import { render, staticRenderFns } from "./MasterGroupCard.vue?vue&type=template&id=3f3bb996"
import script from "./MasterGroupCard.vue?vue&type=script&lang=js"
export * from "./MasterGroupCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports